import React, { useState } from "react";

const API = process.env.REACT_APP_API_URL || "http://localhost:8000";

export default function Paso1Formulario({ onSiguiente }) {
  const [form, setForm] = useState({ nombre: "", telefono: "", email: "" });
  const [rgpd, setRgpd] = useState(false);
  const [error, setError] = useState("");
  const [cargando, setCargando] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setError("");
  };

  const handleSubmit = async () => {
    if (!form.nombre.trim() || !form.telefono.trim() || !form.email.trim()) {
      setError("Por favor, rellena todos los campos.");
      return;
    }
    // Limpiar teléfono: eliminar todo excepto dígitos y +
    const telLimpio = form.telefono.replace(/[^\d+]/g, "");
    if (telLimpio.replace("+", "").length < 9) {
      setError("Introduce un número de teléfono válido.");
      return;
    }

        // Validar email básico
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) {
      setError("Introduce un correo electrónico válido.");
      return;
    }
    if (!rgpd) {
      setError("Debes aceptar el tratamiento de datos para continuar.");
      return;
    }

    setCargando(true);
    try {
      const formData = new FormData();
      formData.append("nombre", form.nombre);
      formData.append("telefono", form.telefono);
      formData.append("email", form.email);
      formData.append("consentimiento", "true");

      const r = await fetch(`${API}/api/lead`, { method: "POST", body: formData });
      const data = await r.json();
      if (!r.ok) throw new Error(data?.detail || "Error al registrar los datos.");

      // Pasamos nombre + lead_id al paso 2
      onSiguiente({ ...form, lead_id: data.id });
    } catch (e) {
      setError(e.message || "Error al conectar con el servidor.");
      setCargando(false);
    }
  };

  return (
    <div>
      <div style={{ textAlign: "center", marginBottom: 36 }}>
        <div style={{
          display: "inline-block", fontFamily: "var(--mono)", fontSize: 11,
          color: "var(--accent)", border: "1px solid rgba(245,166,35,.3)",
          borderRadius: 99, padding: "4px 14px", marginBottom: 16, letterSpacing: "0.1em",
        }}>
          TARIFA 2.0TD · MERCADO ESPAÑOL
        </div>
        <h1 style={{
          fontFamily: "var(--display)", fontSize: "clamp(26px, 5vw, 46px)",
          fontWeight: 800, letterSpacing: "-0.03em", lineHeight: 1.1, marginBottom: 14,
        }}>
          ¿Estás pagando de más<br />
          en tu <span style={{ color: "var(--accent)" }}>factura de luz</span>?
        </h1>
        <p style={{ color: "var(--text2)", fontSize: 15, maxWidth: 480, margin: "0 auto", lineHeight: 1.7 }}>
          Sube tu factura y compara en segundos con todas las tarifas del mercado. Gratis y sin compromiso.
        </p>
      </div>

      <div className="card">
        <div className="card-title">Tus datos de contacto</div>
        <div className="form-grid" style={{ marginBottom: 16 }}>
          <div className="field">
            <label>Nombre y apellidos</label>
            <input type="text" name="nombre" placeholder="María García López"
              value={form.nombre} onChange={handleChange} />
          </div>
          <div className="field">
            <label>Teléfono</label>
            <input type="tel" name="telefono" placeholder="600 000 000"
              value={form.telefono} onChange={handleChange} />
          </div>
          <div className="field" style={{ gridColumn: "1 / -1" }}>
            <label>Correo electrónico</label>
            <input type="email" name="email" placeholder="maria@ejemplo.com"
              value={form.email} onChange={handleChange} />
          </div>
        </div>

        <label className="rgpd-row">
          <input type="checkbox" checked={rgpd}
            onChange={(e) => { setRgpd(e.target.checked); setError(""); }} />
          <span className="rgpd-text">
            He leído y acepto el tratamiento de mis datos personales conforme a la{" "}
            <a href="#politica" onClick={(e) => e.preventDefault()}>Política de Privacidad</a>{" "}
            de Nerón Energía. Mis datos solo se usarán para comparar tarifas y contactarme con una oferta personalizada.
          </span>
        </label>

        {error && (
          <div style={{
            marginTop: 14, background: "rgba(255,91,91,.08)",
            border: "1px solid rgba(255,91,91,.3)", borderRadius: 8,
            padding: "10px 14px", color: "var(--red)", fontSize: 13,
          }}>⚠ {error}</div>
        )}

        <button className="btn btn-primary" onClick={handleSubmit}
          disabled={cargando} style={{ marginTop: 20 }}>
          {cargando ? "Guardando..." : "Continuar →"}
        </button>
      </div>
    </div>
  );
}